import { dispatch } from '@rematch/core';
import { statsService, stripeStatsService, accountUsersService, accountService, accountCountsByPlan, integrationsService, getIntegrationsService } from '../../services/feathers.service';

const initialState = {
  acceptServerEvents: false,
  stripeStats: null,
  activeSessions: 0,
  accountsCount: 0,
  orgCount: 0,
  userCount: 0,
  playbookCount: 0,
  contentCount: 0,
  accounts: [],
  allAccounts: [],
  unRegisteredUsersData: [],
  allUsers: [],
  platformUsers: [],
  platformUsersCount: [],
  totalCount: 0,
  planCounts: {},
  subscriptionListQuery: {},
  newIntegrationFlag: false,
  integrationModalType: ""
};

export default {
  state: initialState,
  reducers: {
    setActiveSessions(state, payload) {
      return {
        ...state,
        activeSessions: payload
      }
    },
    setStripeStats(state, payload) {
      return {
        ...state,
        stripeStats: payload
      }
    },
    setAcceptServerEvents(state, payload) {
      return {
        ...state,
        acceptServerEvents: payload
      }
    },
    setAccountsCount(state, payload) {
      return {
        ...state,
        accountsCount: payload
      }
    },
    setOrgCount(state, payload) {
      return {
        ...state,
        orgCount: payload
      }
    },
    setUserCount(state, payload) {
      return {
        ...state,
        userCount: payload
      }
    },
    setPlaybookCount(state, payload) {
      return {
        ...state,
        playbookCount: payload
      }
    },
    setContentCount(state, payload) {
      return {
        ...state,
        contentCount: payload
      }
    },
    setAccounts(state, payload) {
      return {
        ...state,
        accounts: payload
      }
    },
    setAllAccounts(state, payload) {
      return {
        ...state,
        allAccounts: payload
      }
    },
    setUnRegisteredUsersData(state, payload) {
      return {
        ...state,
        unRegisteredUsersData: payload
      }
    },
    setAllUsers(state, payload) {
      return {
        ...state,
        allUsers: payload
      }
    },
    setTotalCount(state, payload) {
      return {
        ...state,
        totalCount: payload
      }
    },
    setAllPlatformUsers(state, payload) {
      return {
        ...state,
        platformUsers: payload
      }
    },
    setAllPlatformUsersCount(state, payload) {
      return {
        ...state,
        platformUsersCount: payload
      }
    },
    setPlanCounts(state, payload) {
      return {
        ...state,
        planCounts: payload
      }
    },
    setSubscriptionsListQuery(state, payload) {
      return {
        ...state,
        subscriptionListQuery: payload
      }
    },
    setNewIntegrationFlag(state, payload) {
      return {
        ...state,
        newIntegrationFlag: payload
      }
    },

    setNewIntegrationType(state, payload) {
      return {
        ...state,
        integrationModalType: payload
      }
    },
    clear() {
      return initialState
    }
  },
  effects: {
    async getStats(payload, rootState) {
      if (rootState.platform.acceptServerEvents) {
        try {
          const stats = await statsService.find();
          dispatch.platform.setAccountsCount(stats.accountsCount);
          dispatch.platform.setOrgCount(stats.orgCount);
          dispatch.platform.setUserCount(stats.userCount);
          dispatch.platform.setPlaybookCount(stats.playbookCount);
          dispatch.platform.setContentCount(stats.contentCount);
          dispatch.platform.setAccounts(stats.accounts);
          //dispatch.platform.setAllAccounts(stats.allAccounts);
          dispatch.platform.setUnRegisteredUsersData(stats.unRegisteredUsersData);
        } catch (err) {
          dispatch.error.handle(err);
        }
      }
    },
    async getStripeStats(payload, rootState) {
      if (rootState.platform.acceptServerEvents) {
        try {
          const stats = await stripeStatsService.find();
          dispatch.platform.setStripeStats(stats);
        } catch (err) {
          dispatch.error.handle(err);
        }
      }
    },
    // Get all account users
    async getAllAccountUsers(payload) {
      try {
        let query = {

          $limit: payload.query.$limit,
          $skip: payload.query.$skip,
          $sort: payload.query.$sort,
          createdAt: payload.query.createdAt,
        }

        if (payload.query.$and) {
          query.$and = payload.query.$and
        }
        const accountUsers = await accountUsersService.find({
          query: query
        });

        dispatch.platform.setAllUsers(accountUsers);
      } catch (err) {
        dispatch.error.handle(err);
      }
    },

    // Get all account 
    async getAllAccountsWithOwnerDetails(payload,state) {

      let query = payload.query
      let PlanId = "Free"
      if (payload.planIndex === 0) { PlanId = "Free" }
      if (payload.planIndex === 1) { PlanId = "Basic" }
      else if (payload.planIndex === 2) { PlanId = "Standard" }
      else if (payload.planIndex === 3) { PlanId = "Premium" }
      else if (payload.planIndex === 4) { PlanId = "Enterprise" }
      query.planId = { $regex: PlanId, $options: 'i' }
      query.$populate = [
        { path: 'ownerId', select: 'firstName lastName email profilePic' },
        {
          path: 'users.id', select: 'firstName lastName email profilePic'
        },
        {
          path: 'actionLogs.by', select: 'firstName lastName email profilePic'
        },
        {
          path: 'integrations.id', select: '_id label image version description createdAt'
        }
      ]

      try {
        let accountsWithOwnerDetails = await accountService.find({
          query: query
        });

        for (let index = 0; index < accountsWithOwnerDetails.data.length; index++) {
          if (accountsWithOwnerDetails.data[index].ownerId) {
            accountsWithOwnerDetails.data[index].firstName = accountsWithOwnerDetails.data[index].ownerId.firstName;
            accountsWithOwnerDetails.data[index].lastName = accountsWithOwnerDetails.data[index].ownerId.lastName;
            accountsWithOwnerDetails.data[index].profilePic = accountsWithOwnerDetails.data[index].ownerId.profilePic;
            accountsWithOwnerDetails.data[index].isDiactivated = accountsWithOwnerDetails.data[index].isActive;
            accountsWithOwnerDetails.data[index].isActivated = !accountsWithOwnerDetails.data[index].isActive;
          }
        }

        dispatch.platform.setAllAccounts(accountsWithOwnerDetails);
      } catch (err) {
        dispatch.error.handle(err);
      }
    },

    async getAllPlatformUsers(payload) {
      try {
        payload.query.isPlatformUser = true;
        const platformAllUsers = await accountUsersService.find({
          query: payload.query
        });

        dispatch.platform.setAllPlatformUsers(platformAllUsers);
      } catch (err) {
        dispatch.error.handle(err);
      }
    },
    async getAllPlatformUsersCount() {
      try {
        const platformAllUsers = await accountUsersService.find({
          query: {
            "isPlatformUser": true
          }
        });
        dispatch.platform.setAllPlatformUsersCount(platformAllUsers);
      } catch (err) {
        dispatch.error.handle(err);
      }
    },
    async accountsCountsByPlans(payload) {
      let result = await accountCountsByPlan.find({})
      dispatch.platform.setPlanCounts(result);
    },
    updateAccountList(payload, state) {
      if (state.platform.allAccounts && state.platform.allAccounts.data && state.platform.allAccounts.data.length > 0) {
        if (state.platform.allAccounts.data.filter(account => { return account._id.toString() === payload._id.toString() }).length > 0) {
          for (let i = 0; i < state.platform.allAccounts.data.length; i++) {
            if (state.platform.allAccounts.data[i]._id.toString() === payload._id.toString()) {
              state.platform.allAccounts.data[i] = Object.assign({}, state.platform.allAccounts.data[i], { publicAccess: payload.publicAccess, actionLogs: payload.actionLogs });
              break;
            }
          }
          dispatch.platform.setAllAccounts(Object.assign({}, state.platform.allAccounts))
        }
      }
    },
    setIntegrationModal(payload, state) {
      dispatch.platform.setNewIntegrationFlag(payload)
    },
    setIntegrationModalType(payload, state) {
      dispatch.platform.setNewIntegrationType(payload)
    }

  }
}